import { CalendarColumn } from "@tento-ui/components/calendar/calendar-column";
import { PIXELS_PER_HOUR } from "@tento-ui/components/calendar/calendar-hour";
import { CurrentTimeIndicator } from "@tento-ui/components/calendar/current-time-indicator";
import { ColumnIndex } from "@tento-ui/components/sheet/column-index";
import { ZIndex } from "@tento-ui/z-index";
import type { Option } from "@tento-lona/sheets";
import { DateFragment, DateTime, TimeOfDay, Utc } from "@tento-chrono";
import type { SheetNamedChildren } from "./calendar-days-strip.ts";

/**
 * A days strip's current-time line for one day fragment (F11): shown when
 * the clock falls on the fragment's date inside the strip's window, offset
 * from the window start. Moved out of calendar-days-strip.ts unchanged.
 */
export function bindCurrentTime(
  $column: CalendarColumn<SheetNamedChildren>,
  df: DateFragment,
  currentTime: DateTime<Utc>,
  window: Option<TimeOfDay.Range>,
  column: ColumnIndex.Key.Resolved.Default,
) {
  const dtl = currentTime.toTz(df.tz);

  const isOnSameDate = df.inner.containsExclusiveEnd(dtl);
  if (!isOnSameDate) {
    $column.removeNamedChild("timeIndicator");
    return;
  }
  if (window && !window.contains(dtl.time)) {
    $column.removeNamedChild("timeIndicator");
    return;
  }

  const $line = $column.$namedChildOrElse(
    "timeIndicator",
    CurrentTimeIndicator.make.bind(CurrentTimeIndicator),
  );

  let offset = dtl.time.duration().sub(window?.start.duration() ?? {});
  if (column.partialLocalTop) {
    offset = offset.sub({
      ms: column.partialLocalTop.time.toMs,
    });
  }

  $line.assignStyles({
    position: "absolute",
    top: "0px",
    left: "0px",
    transform: `translateY(calc(${PIXELS_PER_HOUR}px * ${offset.toHrsF}))`,
    zIndex: String(ZIndex.STICKY),
  });

  $column.appendChild($line);
}
